import { Link } from "react-router";

export type AnnotationLinkProps = {
  /** The URL to link to */
  href: string;
  /** The content to display inside the link */
  children: React.ReactNode;
  /** Optional callback function to execute when the link is clicked */
  callback?: () => void;
  /** Optional attributes to apply to the link */
  attributes?: Record<string, string>;
};

/**
 * AnnotationLink component that renders a link with optional callback and attributes.
 */
const AnnotationLink = ({
  href,
  children,
  attributes,
  callback,
}: AnnotationLinkProps) => {
  return (
    <Link
      onClick={callback}
      to={href}
      className="text-verticals-btblue underline"
      target="_blank"
      data-testid="article-annotation-link-component"
      {...attributes}
      reloadDocument
    >
      {children}
    </Link>
  );
};

export default AnnotationLink;
